<div>
    <mat-table class="w-100 splits-table bg-transparent" [dataSource]="value" #matTable>
      <ng-container matColumnDef="quantity">
        <mat-header-cell *matHeaderCellDef class="qty-cell">Quantity</mat-header-cell>
        <mat-cell *matCellDef="let row" class="qty-cell">
            <mat-form-field class="w-100 mat-input-no-message">
                <input [readonly]="!!row.floorReleaseId" matInput type="number" min="0" step="1" [(ngModel)]="row.quantity" (ngModelChange)="this.onChange(this.value)">
            </mat-form-field>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="dueDate">
        <mat-header-cell *matHeaderCellDef class="date-cell">Delivery Date</mat-header-cell>
        <mat-cell *matCellDef="let row" class="date-cell">
            <date-picker [readonly]="!!row.floorReleaseId" appearance="outline" class="w-100" placeholder="" [(ngModel)]="row.dueDate" (ngModelChange)="this.onChange(this.value)"
              [editable]="true"></date-picker>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="previewTraveler">
        <mat-header-cell *matHeaderCellDef class="pl-2 ml-auto">&nbsp;</mat-header-cell>
        <mat-cell *matCellDef="let row, let i = index" class="pl-2 ml-auto">
          <button mat-stroked-button class="button-text" [disabled]="!row.quantity || !row.dueDate" (click)="previewTraveler.emit(row)">
            Preview Traveler
          </button>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="release">
        <mat-header-cell *matHeaderCellDef class="pl-2">&nbsp;</mat-header-cell>
        <mat-cell *matCellDef="let row, let i = index" class="pl-2">
          <button *ngIf="!row.floorReleaseId" mat-flat-button class="button-text" [disabled]="!row.quantity || !row.dueDate || !isAllPlanned"
          [class.bg-success]="!(!row.quantity || !row.dueDate || !isAllPlanned)"
          [class.text-white]="!(!row.quantity || !row.dueDate || !isAllPlanned)"
          (click)="doRelease.emit(row)">
            Release Traveler
          </button>
          <button *ngIf="!!row.floorReleaseId" mat-flat-button class="bg-danger text-white button-text" (click)="unrelease.emit(row)">
            Unrelease Traveler
          </button>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="delete">
        <mat-header-cell *matHeaderCellDef class="pl-2">&nbsp;</mat-header-cell>
        <mat-cell *matCellDef="let row, let i = index" class="pl-2">
          <button *ngIf="!row.floorReleaseId" mat-flat-button color="warn" class="mat-square-button" (click)="remove(i)"><mat-icon>delete</mat-icon></button>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="add">
        <mat-cell *matFooterCellDef>
          <button mat-flat-button color="primary" [disabled]="!unassignedQty" (click)="add()"><mat-icon matPrefix>add</mat-icon>Add Release (Unassigned Quantity: {{ unassignedQty }})</button>
        </mat-cell>
      </ng-container>
    
      <mat-header-row *matHeaderRowDef="['quantity', 'dueDate', 'previewTraveler', 'release', 'delete']" class="mb-1"></mat-header-row>
      <mat-row *matRowDef="let row; columns: ['quantity', 'dueDate', 'previewTraveler', 'release', 'delete']"></mat-row>
      <mat-footer-row *matFooterRowDef="['add']"></mat-footer-row>
    </mat-table>
</div>